

































































import {
  Component, Vue, Prop,
} from 'vue-property-decorator';
import VueToExcel from 'vue-json-excel';
import SnackBarService from '@/shared/snackbar/snackbar.service';
import DropdownComponent from '@/shared/dropdown/dropdown.component.vue';
import ButtonComponent from '@/shared/button/button.component.vue';
import OverlayLoader from '@/shared/overlay-loader/overlay-loader.component.vue';
import WorkItemService from '@/domain/work-item/work-item.service';
import OptionFilter from '@/views/work-item/option-filter.json';
import WorkItemExport from '@/domain/work-item/work-item-export.entity';
import WorkItemFilter from '@/domain/work-item/work-item-filter.entity';

@Component({
  components: {
    ButtonComponent,
    DropdownComponent,
    VueToExcel,
    OverlayLoader,
  },
})
export default class WorkItemModalExport extends Vue {
  @Prop() dialog!: boolean;

  @Prop() projectId!: string;

  @Prop() filter!: WorkItemFilter;

  workItems: WorkItemExport[] = [];

  loading: boolean = false;

  exportPreference: string = '';

  options: any[] = OptionFilter;

  get optionsTranslated() {
    return this.options.map(option => ({
      value: option.value,
      label: this.$t(option.label),
    }));
  }

  cancel() {
    this.exportPreference = '';
    this.dialog = false;
    this.$emit('cancel');
  }

  csvLabel = {
    NUMBER: 'workItemNumber',
    'CODE SOURCE': 'origin',
    STATUS: 'status',
    TITLE: 'title',
    'WORK ITEM TYPE': 'workItemType',
    'CREATED DATE': 'createdDate',
    'ORIGIN CREATED DATE': 'originCreatedDate',
    'ESTIMATED DEADLINE': 'estimatedDeadLine',
    'CLOSED DATE': 'concludedAt',
    'CREATED BY': 'createdBy',
    'ASSIGNED TO': 'assignedTo',
    'ORIGINAL ESTIMATE': 'originalEstimate',
    'EFFORT SPENT': 'effortSpent',
    'ORIGIN SYSTEM': 'originSystem',
    DELIVERY: 'deliveryFormatted',
    'IS AGGREGATOR': 'isAggregatorFormatted',
    'PARENT NUMBER': 'parentNumber',
  }

  getWorkItemExport() {
    this.loading = true;
    this.filter.aggregatorsAndOrphanTasks = false;
    this.filter.filterChildren = false;
    this.filter.onlyChildren = false;
    return WorkItemService.searchAllWorkItemsToExport(
      this.projectId,
      this.exportPreference,
      this.filter,
    ).then((response: any) => {
      this.workItems = WorkItemExport.ofList(response);
      return this.workItems;
    })
      .catch((err) => {
        SnackBarService.errorMessage(err.response.data.messages);
        return [];
      })
      .finally(() => this.loading = false);
  }

  inputPreference(value: any) {
    this.exportPreference = value.value || '';
  }
}
